import React from "react";
import { useTranslation } from "react-i18next";   
import ReactApexChart from "react-apexcharts";
import { Box, Paper, Typography } from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";

const ProfitBreakdown = ({ sellsItem, expenses }) => {
  const { t } = useTranslation();
  const [sellItems, setSellItems] = useState(0);
  const [sellPrice, setSellPrice] = useState(0);
  const [purchPrice, setPurchPrice] = useState(0);
  const [totalExp, setTotalExp] = useState(0);

  useEffect(() => {

  const now = new Date();

  const monthlySells = sellsItem.filter((j) => {
    const sellDate = new Date(`${j.sellDate}Z`);

    return (
      sellDate.getFullYear() === now.getFullYear() &&
      sellDate.getMonth() === now.getMonth()
    );
  });

    setSellItems(monthlySells.map((j) => j.qty).reduce((x, y) => x + y, 0));
    setSellPrice(
      monthlySells
        .map((j) => Math.round(j.qty * j.price))
        .reduce((x, y) => x + y, 0)
    );
    setPurchPrice(
      monthlySells
        .filter((j) => j.itemType === 1)
        .map((j) => Math.round(j.qty * j.product.purchPrice))
        .reduce((x, y) => x + y, 0)
    );

    setTotalExp(
      expenses
        .filter((j) => {
          const expenseDate = new Date(j.addDate);

          return (
            expenseDate.getFullYear() === now.getFullYear() &&
            expenseDate.getMonth() === now.getMonth()
          );
        })
        .map((j) => Math.round(j.amount))
        .reduce((x, y) => x + y, 0)
    );

  }, [sellsItem, expenses]);

  const options = {
    chart: {
      type: "donut",
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 90,
        offsetY: 10,
        donut: {
          labels: {
            show: true,
          },
        },
      },
    },
    grid: {
      padding: {
        bottom: -90,
      },
    },
    labels: [
      t("numberOfItemsSold"),
      t("sellPrice"),
      t("purchasePrice"),
      t("totalExpense"),
    ],
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: "gradient",
    },
    legend: {
      formatter: function (val, opts) {
        return val + " - " + opts.w.globals.series[opts.seriesIndex];
      },
      show: true,
      position: "bottom",
      horizontalAlign: "bottom",
      fontSize: "16px",
      fontWeight: "600",
      itemMargin: {
        horizontal: 10,
        vertical: 8,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: "100%",
          },
        },
      },
    ],
  };

  const series = [
    sellItems,
    parseInt(sellPrice),
    parseInt(purchPrice),
    parseInt(totalExp),
  ];

  return (
    <Paper className="shadow-xs p-15 br-6">
      {/* Chart */}
      <Typography variant="h6" className="fs-18 fw-5 gray-color mb-10">
        {t("profitBreakdown")}
      </Typography>
      <Box>
        <ReactApexChart
          options={options}
          series={series}
          type="donut"
          height={330}
        />
      </Box>
    </Paper>
  );
};

export default ProfitBreakdown;
